export default __webpack_public_path__ + "static/media/loader.4c8b46d4.svg";